var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100vh"}},[_c('div',{staticStyle:{"color":"red","position":"absolute","left":"46%","top":"50%"}},[_c('vue-loaders-pacman',{attrs:{"color":"currentColor","scale":"1"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }